import axios from "axios";
import { msalInstance } from "../msalInstance";
import { loginRequest } from "../msalConfig";

export async function getCurrentUserEmail(): Promise<string> {
  const account = msalInstance.getActiveAccount();
  if (!account) throw new Error("No signed-in user");

  // Get a user token to call /me
  const { accessToken } = await msalInstance.acquireTokenSilent({
    ...loginRequest,
    account,
    scopes: ["User.Read"]
  });

  const { data } = await axios.get("https://graph.microsoft.com/v1.0/me", {
    headers: { Authorization: `Bearer ${accessToken}` }
  });

  // Prefer mailbox address; fallback to UPN
  return data?.mail || data?.userPrincipalName || account.username;
}
